import { useState, useEffect, useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useEditMode } from '../../context/EditModeContext';
import { useEditorCapability } from '../../hooks/useEditorCapability';
import { useIsMobile } from '../../hooks/useIsMobile';
import { useT } from '../../hooks/useT';
import { acquireModalLock } from '../../utils/modalLock';
import styles from './AdminGate.module.css';

const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD || 'admin123';

function AdminGate() {
  const [searchParams, setSearchParams] = useSearchParams();
  const { setEditMode } = useEditMode();
  const { supported } = useEditorCapability();
  const isMobile = useIsMobile();
  const t = useT();
  const [showPrompt, setShowPrompt] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (sessionStorage.getItem('fgl_admin') === 'true') {
      setEditMode('admin');
      return;
    }
    if (searchParams.get('admin') === 'true') {
      setShowPrompt(true);
    }
  }, [searchParams, setEditMode]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      sessionStorage.setItem('fgl_admin', 'true');
      setEditMode('admin');
      setShowPrompt(false);
      setPassword('');
      const newParams = new URLSearchParams(searchParams);
      newParams.delete('admin');
      setSearchParams(newParams, { replace: true });
    } else {
      setError('Incorrect password');
      setPassword('');
    }
  };

  const handleClose = useCallback(() => {
    setShowPrompt(false);
    setPassword('');
    setError('');
    const newParams = new URLSearchParams(searchParams);
    newParams.delete('admin');
    setSearchParams(newParams, { replace: true });
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    if (!showPrompt) return undefined;

    const release = acquireModalLock();

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        handleClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      release();
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [showPrompt, handleClose]);

  if (!showPrompt) return null;

  if (isMobile && !supported) {
    return (
      <div className={styles.overlay}>
        <div className={styles.modal}>
          <p className={styles.unsupported}>
            {t(
              'editor.unsupportedBrowser',
              'Editing needs a newer mobile browser. Open this page on a computer, or update your browser to try it.'
            )}
          </p>
          <div className={styles.buttons}>
            <button type="button" className={styles.cancelBtn} onClick={handleClose}>
              {t('editor.close', 'Close')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h3 className={styles.title}>Admin Access</h3>
        <form onSubmit={handleSubmit} className={styles.form}>
          <input
            type="password"
            value={password}
            onChange={(e) => { setPassword(e.target.value); setError(''); }}
            placeholder="Enter admin password"
            className={styles.input}
            autoFocus
          />
          {error && <p className={styles.error}>{error}</p>}
          <div className={styles.buttons}>
            <button type="submit" className={styles.submitBtn}>Enter</button>
            <button type="button" className={styles.cancelBtn} onClick={handleClose}>{t('editor.cancel', 'Cancel')}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AdminGate;
